import auth from './modules/auth'
import entities from './modules/entities'
import jobs from './modules/jobs'
import tasks from './modules/tasks'
import rates from './modules/rates'
import warehouse from './modules/warehouse'
import mailTemplates from './modules/mailtemplates'
import products from './modules/products'
import settings from './modules/settings'
import reports from './modules/reports'
import files from './modules/files'
import stock from './modules/stock'
import notes from './modules/notes'

export default {
    auth: auth,
    entities: entities,
    jobs: jobs,
    tasks: tasks,
    rates: rates,
    warehouse: warehouse,
    mailTemplates: mailTemplates,
    products: products,
    settings: settings,
    reports: reports,
    files: files,
    stock: stock,
    notes: notes
}